import { type AnnouncementAction, isAnnouncementCommandAction } from '../constants';
import { getAnnouncementLinkHref } from './getAnnouncementLinkHref';

// The authoring API caps an announcement at three actions; keep the render limit matching it.
const MAX_VISIBLE_ACTIONS = 3;

export const visibleAnnouncementActions = (actions?: readonly AnnouncementAction[]) => {
  return (actions ?? [])
    .filter((action) => isAnnouncementCommandAction(action) || getAnnouncementLinkHref(action.url) !== null)
    .slice(0, MAX_VISIBLE_ACTIONS);
};
